import { isValidDateInstance } from './isValidDateInstance';

export function isValidDateRange(range: any): range is [Date, Date] {
    return isValidDateInstance(range?.[0]) && isValidDateInstance(range?.[1]);
}
